<template>
  <div class="f_bg">
    <div class="footer">
      <div class="f_nav fl">
        <ul class="f_ul01">
          <li class="f_li01 f_lis">
            <router-link to="/about" title="关于我们">关于我们</router-link>
            <ul class="f_ul02">
              <!-- 2级 -->
              <li>
                <router-link to="/about" title="公司简介">公司简介</router-link>
              </li>
              <li>
                <router-link to="/about/honor" title="资质荣誉"
                  >资质荣誉</router-link
                >
              </li>
              <li>
                <router-link to="/about/album" title="企业相册"
                  >企业相册</router-link
                >
              </li>
              <li>
                <router-link to="/case/customer" title="客户见证"
                  >客户见证</router-link
                >
              </li>
            </ul>
          </li>
          <li class="f_li01 f_lim">
            <router-link to="/products/all" title="产品展示"
              >产品展示</router-link
            >
            <ul class="f_ul02">
              <!-- 2级 -->
              <li v-for="(item, index) in newProType" :key="index">
                <router-link
                  :to="n.name | toProDetail('/products/')"
                  :title="n.name"
                  v-for="(n, i) in item"
                  :key="i"
                  >{{ n.name }}</router-link
                >
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="f_ban fl">
        <em>联系我们</em>
        <p class="f_p01">400-677-1996</p>
        <p class="f_p01">17746996888</p>
        <p class="f_p02">河南省许昌市襄城县紫云镇工业园区</p>
        <div>
          <a href="/map">站点地图</a>&nbsp;&nbsp;<a
            href="/sitemap.xml"
            target="_blank"
          >
            XML地图
          </a>
        </div>
      </div>
      <div class="f_er fr">
        <em>二维码</em>
        <p>
          <img
            alt="河南万杰智能科技股份"
            src="@img/ma2.jpg"
            title="河南万杰智能科技股份"
          />
        </p>
      </div>
      <div class="clear"></div>
    </div>
    <div class="f_cen">
      <div
        class="img"
        v-for="(item, index) in [
          {
            img: 'http://wxsmjphoto.wanjiejixie.com/web_img/001.png',
            name: '微信视频号'
          },
          {
            img: 'http://wxsmjphoto.wanjiejixie.com/web_img/002.png',
            name: '快手：面条机',
            tip: 'ID：1653631971'
          },
          {
            img: 'http://wxsmjphoto.wanjiejixie.com/web_img/003.png',
            name: '抖音：面条机',
            tip: 'ID：miantiaoji777'
          },
          {
            img: 'http://wxsmjphoto.wanjiejixie.com/web_img/004.png',
            name: '快手：馒头机',
            tip: 'ID：mantouji666'
          },
          {
            img: 'http://wxsmjphoto.wanjiejixie.com/web_img/005.png',
            name: '抖音：馒头机',
            tip: 'ID：mantouji666'
          }
        ]"
        :key="index"
      >
        <img :src="item.img" />
        <div class="title">{{ item.name }}</div>
        <div class="tip" v-if="item.tip">{{ item.tip }}</div>
      </div>
    </div>
    <div class="f_bot">
      Copyright © 万杰智能科技股份有限公司 版权所有
      <a
        href="http://wxsmjphoto.wanjiejixie.com/gs/wjzhizhao.png"
        target="_blank"
        >营业执照</a
      >&nbsp;&nbsp;<a href="http://beian.miit.gov.cn/"
        >备案号: 豫ICP备10008366号-1</a
      >
    </div>
  </div>
</template>

<script>
import utils from "@/api/to_py.js";
export default {
  data() {
    return {
      products: []
    };
  },
  created() {
    this.getRroductType();
  },
  methods: {
    getRroductType: function() {
      this.$post("/Product/product_class_list", {}).then(response => {
        this.products = response.data || [];
      });
    }
  },
  filters: {
    toProDetail(parm, url) {
      var str = utils.ConvertPinyin(parm);
      if (url) str = url + str;
      return str;
    }
  },
  computed: {
    newProType() {
      var arr2 = [];
      var arr = this.products,
        size = 3;
      for (var i = 0; i < arr.length; i = i + size) {
        arr2.push(arr.slice(i, i + size));
      }
      return arr2; // 新的二维数组
    }
  }
};
</script>

<style lang="less">
.f_bg {
  background-color: rgba(37, 36, 38, 1);
  padding: 36px 0 0;
  overflow: hidden;
  .footer {
    width: 1200px;
    margin: 0 auto;
    .f_nav {
      // width: 600px;
      // height: 318px;
      overflow: hidden;
      padding: 0 0 0 5px;
      .f_li01 {
        float: left;
      }
      .f_lis {
        width: 200px;
      }
      .f_lim {
        width: 400px;
        li {
          width: 100%;
        }
      }
      li {
        float: left;
        a {
          width: 130px;
          font-size: 19px;
          color: rgba(255, 255, 255, 1);
          font-weight: bold;
          height: 60px;
          line-height: 60px;
          overflow: hidden;
          display: block;
        }
      }
      .f_ul02 li a {
        font-size: 15px;
        color: rgba(255, 255, 255, 0.5);
        font-weight: normal;
        height: 30px;
        line-height: 30px;
        display: inline-block;
      }
    }
    .f_ban {
      // height: 250px;
      padding: 0 0 0 100px;
      width: 290px;
      em {
        display: block;
        font-size: 18px;
        color: #fff;
        font-weight: bold;
        height: 60px;
        line-height: 60px;
        overflow: hidden;
      }
      p {
        font-size: 15px;
        color: rgba(255, 255, 255, 0.5);
        line-height: 34px;
        padding: 0 0 0 30px;
      }
      .f_p01 {
        background: url(~@img/f_ico02.gif) no-repeat 0 center;
        background-size: 20px 20px;
      }
      .f_p02 {
        background: url(~@img/f_ico04.gif) no-repeat 0 center;
        background-size: 20px 20px;
      }
      a {
        font-size: 15px;
        line-height: 34px;
        color: rgba(255, 255, 255, 0.5);
        &:hover {
          color: rgba(255, 255, 255, 1);
        }
      }
    }
    .f_er {
      em {
        display: block;
        font-size: 18px;
        color: #fff;
        font-weight: bold;
        height: 60px;
        line-height: 60px;
        overflow: hidden;
      }
      p {
        width: 125px;
        text-align: center;
        float: left;
        padding: 0 20px 0 0;
        img {
          width: 125px;
          height: 125px;
        }
      }
    }
  }
  .f_cen {
    width: 1200px;
    padding-bottom: 40px;
    margin: 20px auto 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .img {
      img {
        width: 100px;
        height: 100px;
        // background: #fff;
      }
    }
    .title {
      margin-top: 8px;
      text-align: center;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 20px;
      letter-spacing: 0px;
      color: #727272;
    }
    .tip {
      margin-top: 5px;
      text-align: center;
      font-family: MicrosoftYaHei;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #727272;
    }
  }
  .f_bot {
    margin-top: 10px;
    background-color: rgba(30, 29, 31, 1);
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.5);
    overflow: hidden;
    span {
      padding: 0 20px;
    }
    a {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.5);
    }
  }
  a:hover {
    color: #ffffff !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue